import { render, staticRenderFns } from "./PaketWisataItinerary.vue?vue&type=template&id=d3dc7db6"
import script from "./PaketWisataItinerary.vue?vue&type=script&lang=js"
export * from "./PaketWisataItinerary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports